document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".reviews__container.splide")
    .forEach(function (slider) {
      const pageWidth = slider.closest(".page-width");
      const headerNavigation = pageWidth
        ? pageWidth.querySelector(".reviews__navigation")
        : null;
      const headerPrevButton = headerNavigation
        ? headerNavigation.querySelector(".splide__arrow--prev")
        : null;
      const headerNextButton = headerNavigation
        ? headerNavigation.querySelector(".splide__arrow--next")
        : null;

      // Get Splide's placeholder for arrows
      const splideArrowsPlaceholder = slider.querySelector(".splide__arrows");

      // Move custom arrows from header to Splide's placeholder before initialization
      if (splideArrowsPlaceholder && headerPrevButton && headerNextButton) {
        // Clear placeholder
        splideArrowsPlaceholder.innerHTML = "";
        // Move buttons from header to placeholder
        splideArrowsPlaceholder.appendChild(headerPrevButton);
        splideArrowsPlaceholder.appendChild(headerNextButton);

        // Ensure buttons have correct classes
        headerPrevButton.classList.add("splide__arrow", "splide__arrow--prev");
        headerNextButton.classList.add("splide__arrow", "splide__arrow--next");
      }

      const splide = new Splide(slider, {
        type: "loop",
        gap: "24px",
        pagination: false,
        arrows: true,
        perPage: 4,
        perMove: 1,
        fixedHeight: "400px",
        breakpoints: {
          600: {
            gap: "16px",
            arrows: false,
            fixedWidth: "300px",
          },
          990: {
            perPage: 2,
          },
          1400: {
            perPage: 3,
          },
        },
      });

      // Handle overflow - hide arrows/drag when not enough slides
      splide.on("overflow", function (isOverflow) {
        // Reset the carousel position
        splide.go(0);

        // Toggle options based on overflow
        splide.options = {
          arrows: isOverflow,
          drag: isOverflow,
          clones: isOverflow ? undefined : 0, // Toggle clones
        };

        // Toggle overflow class on slider container
        if (isOverflow) {
          slider.classList.add("is-overflow");
        } else {
          slider.classList.remove("is-overflow");
        }

        // Toggle header navigation visibility based on overflow
        if (headerNavigation) {
          if (isOverflow) {
            headerNavigation.classList.add("is-overflow");
            headerNavigation.classList.remove("is-not-overflow");
          } else {
            headerNavigation.classList.add("is-not-overflow");
            headerNavigation.classList.remove("is-overflow");
          }
        }
      });

      splide.mount();

      // Set initial overflow state after mount
      setTimeout(function () {
        const isOverflow = slider.classList.contains("is-overflow");
        if (headerNavigation) {
          if (isOverflow) {
            headerNavigation.classList.add("is-overflow");
            headerNavigation.classList.remove("is-not-overflow");
          } else {
            headerNavigation.classList.add("is-not-overflow");
            headerNavigation.classList.remove("is-overflow");
          }
        }
      }, 100);

      // After mounting, move arrows back to header for positioning
      if (
        splideArrowsPlaceholder &&
        headerNavigation &&
        headerPrevButton &&
        headerNextButton
      ) {
        const mountedPrevButton = splideArrowsPlaceholder.querySelector(
          ".splide__arrow--prev"
        );
        const mountedNextButton = splideArrowsPlaceholder.querySelector(
          ".splide__arrow--next"
        );

        if (mountedPrevButton && mountedNextButton) {
          // Clear header and move mounted buttons back
          headerNavigation.innerHTML = "";
          headerNavigation.appendChild(mountedPrevButton);
          headerNavigation.appendChild(mountedNextButton);

          // Ensure classes are maintained
          mountedPrevButton.classList.add(
            "splide__arrow",
            "splide__arrow--prev",
            "reviews__nav-button"
          );
          mountedNextButton.classList.add(
            "splide__arrow",
            "splide__arrow--next",
            "reviews__nav-button"
          );
        }
      }
    });
});
